module.exports = __webpack_public_path__ + "img/ico_captain.15ba162b.png";